<template>
  <a-select
    showSearch
    v-model="model"
    :placeholder="placeholder"
    :defaultActiveFirstOption="false"
    :filterOption="false"
    @search="handleSearch"
    @change="handleChange"
    :notFoundContent="null"
    allowClear
  >
    <a-select-option
      v-for="option in options"
      :key="option.id"
      :value="option.id"
    >{{option.name}}</a-select-option>
  </a-select>
</template>
<script>
import { getBusinessOptions } from '@/api/businessBase'
export default {
  name: 'BasePicker',
  data() {
    return {
      //        model:undefined,
      options: []
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    field: {
      type: String | Number,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择基地'
    }
  },
  computed: {
    model: {
      get: function() {
        return this.formData[this.field]
      },
      set: function() {}
    }
  },
  watch: {},
  created() {},
  methods: {
    handleSearch(value) {
      console.log(value)
      let that = this
      getBusinessOptions({ keywords: value }).then(res => {
        console.log(res)
        that.options = res.data
      })
    },
    handleChange(value) {
      this.formData[this.field] = value
    },
    
  }
}
</script>
<style>
</style>